import { cx } from '@linaria/core';
import { ChangeEventHandler, FocusEventHandler, KeyboardEventHandler, ReactNode, Ref, useId } from 'react';
import { fieldErrorStyles, fieldFullWidthStyles, fieldLabelStyles, fieldSmallStyles, fieldSpacedStyles, fieldStyles } from './fieldStyles';
import "./TextField.linaria.module.css!=!./TextField?./TextField.linaria.module.css?css=H4sIAAAAAAAAA52RW2+DIACF3/creFliEzGi9uZ+jEGESuVWRLRttt++tOl6SVztlvBASL5zDudE2MkC7coVT1nBK8M2GYgYp6KCXJnO5bkRmNBai4raozaYcLfP44/Pt+hE1hj1QhRYEbl/BjqLVcsd1yq/aIAkjmULSFdyAkt64NQGcQhOJ0pCgGZXi2y7XWVFUy6VPzxaME26djwh+sERW/VplxR6v6iScoT/ujwJXFIRTjJKu+DeEba17tXsQeUo8QB7Xrk6J1iQAKXpO4AgTcxw+xZex0wWjVw7b16L9QR5KdV5BKatzM83gR0NUGaGEMC1GWagJVjQII6W82tKhLiXlSxWmfKNnIp5JFpom3tsAwiN5RLbPXR0cDe9+QJ53RZItzud+CeCunOCKwoE3VBVhdP0RAWPencLoTh+v8Zbsk5v+9HhYU/LhjuIO6cZF+LPi2/Rwtd0dL7n2v/ZrRN+3drxpn5zm6roGy83nQgsBAAA"
const textFieldLabelledStyles = "atm_1qb8i3f_idpfg4 atm_ha1wll_ancmy4 atm_h4jj84_kb7nvz atm_1f8w3u2_oy6d2b atm_ha90fm_km9tvp atm_11ivmdm_84nvkm atm_1561vos_1osqo2v atm_17fuojw_oy6d2b atm_j16vhe_km9tvp atm_1ulv9sr_1osqo2v";
export interface TextFieldProps {
  autoComplete?: string;
  autoFocus?: boolean;
  className?: string;
  'data-testid'?: string;
  defaultValue?: string;
  disabled?: boolean;
  error?: boolean;
  fullWidth?: boolean;
  helperText?: ReactNode;
  id?: string;
  inputRef?: Ref<any>;
  label?: ReactNode;
  multiline?: boolean;
  name?: string;
  onBlur?: FocusEventHandler<any>;
  onChange?: ChangeEventHandler<any>;
  onFocus?: FocusEventHandler<any>;
  onKeyDown?: KeyboardEventHandler<any>;
  onKeyUp?: KeyboardEventHandler<any>;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  small?: boolean;
  spaced?: boolean;
  type?: string;
  value?: string;
}
const TextField = (props: TextFieldProps) => {
  const {
    className,
    error = false,
    fullWidth = false,
    helperText,
    id,
    inputRef,
    label,
    multiline = false,
    placeholder,
    required = false,
    rows,
    small = false,
    spaced = false,
    type,
    'data-testid': dataTestId,
    ...sharedProps
  } = props;
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const hasLabel = label !== undefined && label !== null;
  const hasValue = typeof sharedProps.value === 'string' && sharedProps.value.length > 0;
  const labelContent = <>
            {label}
            {required && ' *'}
        </>;
  const fieldProps = {
    ...sharedProps,
    className: 'field-input',
    id: inputId,
    placeholder: hasValue ? undefined : placeholder ?? (hasLabel ? ' ' : undefined),
    ref: inputRef,
    required
  };
  return <div className={cx('mfc-text-field', error && 'mfc-error', fieldStyles, hasLabel && fieldLabelStyles, hasLabel && textFieldLabelledStyles, small && fieldSmallStyles, error && fieldErrorStyles, fullWidth && fieldFullWidthStyles, spaced && fieldSpacedStyles, className)} data-testid={dataTestId}>
            <div className="field-control">
                {multiline ? <textarea {...fieldProps} rows={rows} /> : <input {...fieldProps} type={type} />}
                {hasLabel && <label className="field-label" htmlFor={inputId}>
                        {labelContent}
                    </label>}
                <fieldset aria-hidden="true" className="field-outline">
                    <legend>
                        <span>{hasLabel ? labelContent : '​'}</span>
                    </legend>
                </fieldset>
            </div>
            {helperText !== undefined && helperText !== null && <div className="field-helper">{helperText}</div>}
        </div>;
};
export default TextField;